import React,{useState, useEffect} from 'react';
import './cardOpinion.scss';
import Rating from '@material-ui/lab/Rating';
import moment from 'moment';
import { storage, firestore} from '../../../configs/environments/firebase/firebaseApp';

const InfoCardOpinion = ({item ,opinionsLaw}) => {

  let [rests, setRests] = useState()

  useEffect(() => {
    getDocumentsSnapshots()
  }, []) 

  const getDocumentsSnapshots = () => {
      var query = item.clientUid && firestore.collection("client").doc(item.clientUid).get()
   .then(function(querySnapshot) {
      //console.log('querySnapshot', querySnapshot.data())
      setRests(querySnapshot.data())
          
   })
   .catch(function(error) {});

 }
 /* useEffect(() => {
   fetchMyAPI()
   docs && getOpinions(docs).then(docs => setDocs(docs));
 }, []);

 */





    return ( 
        <>
          {item && item.show ? (
            <article className="cardOpi">
              <div className="cardOpi_cali">
                <div className="cardOpi_cali_text">
                  {`${item.rating}/5`}
                </div>
                <div className="cardOpi_cali_stars">
                  <Rating name="half-rating-read" defaultValue={item.rating} precision={0.5} readOnly />
                </div>
              </div>
              <header className="cardOpi_header">
                <p className="cardOpi_header_title">
                  {rests && rests.displayName ? rests.displayName : (rests && rests.name  ? `${rests.name} ${rests.lastName}` : '') }
                </p>
                <p className="cardOpi_header_fecha">
                  {moment.unix(item.createdAt.seconds, 'DD-MM-YYYY HH:mm ').fromNow()}
                </p>
              </header>
              <div className="cardOpi_text">
                <p>
                  "{item.opinion}"
                </p>
              </div>
            </article>) : ('')
          } 
        </>
     );
}
 
export default InfoCardOpinion;